/* tslint:disable */
/* eslint-disable */
import { FrageDisplayModel as AceXFoundPortalCoreCaqModelsFrageDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/frage-display-model';
import { LocalizedTextDisplayModel as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { GlobalEnumsAceBerechnungsmethode as AceXFoundPortalCoreEntitiesGlobalEnumsAceBerechnungsmethode } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-berechnungsmethode';
import { GlobalEnumsAceFormulartyp as AceXFoundPortalCoreEntitiesGlobalEnumsAceFormulartyp } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-formulartyp';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { FrageDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsFrageDisplayModelFormGroup } from '@/api/model-index';
import { LocalizedTextDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup } from '@/api/model-index';

export interface IAbschnittDisplayModel {
  abschnitte?: null | Array<AbschnittDisplayModel>;
  beantragteFoerdersumme?: null | number;
  berechnungsmethode?: AceXFoundPortalCoreEntitiesGlobalEnumsAceBerechnungsmethode;
  formularTyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAceFormulartyp;
  fragen?: null | Array<AceXFoundPortalCoreCaqModelsFrageDisplayModel>;
  id?: string;
  infotext?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  kurzTitel?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  name?: null | string;
  parentId?: null | string;
  reihenfolge?: number;
}
export class AbschnittDisplayModel extends BaseModel implements IAbschnittDisplayModel {
  abschnitte?: null | Array<AbschnittDisplayModel>;
  beantragteFoerdersumme?: null | number;
  berechnungsmethode?: AceXFoundPortalCoreEntitiesGlobalEnumsAceBerechnungsmethode;
  formularTyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAceFormulartyp;
  fragen?: null | Array<AceXFoundPortalCoreCaqModelsFrageDisplayModel>;
  id?: string;
  infotext?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  kurzTitel?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  name?: null | string;
  parentId?: null | string;
  reihenfolge?: number;
}
class BaseAbschnittDisplayModelFormGroup extends FormGroup {
  private static _instance: AbschnittDisplayModelFormGroup;
  
  public static get Instance(): AbschnittDisplayModelFormGroup {
    this._instance = new AbschnittDisplayModelFormGroup({
      abschnitte: new FormArray([]),
      beantragteFoerdersumme: new FormControl(null),
      berechnungsmethode: new FormControl(null),
      formularTyp: new FormControl(null),
      fragen: new FormArray([]),
      id: new FormControl(null),
      infotext: new FormArray([]),
      kurzTitel: new FormArray([]),
      name: new FormControl(null),
      parentId: new FormControl(null),
      reihenfolge: new FormControl(null),
    });

    return this._instance;
  }
}


export class AbschnittDisplayModelFormGroup extends BaseAbschnittDisplayModelFormGroup {
  public get Abschnitte(): FormArray<FormControl<null> | AbschnittDisplayModelFormGroup> {
    return this.controls["abschnitte"] as FormArray<FormControl<null> | AbschnittDisplayModelFormGroup>;
  }
  public get BeantragteFoerdersumme(): FormControl {
    return this.controls["beantragteFoerdersumme"] as FormControl;
  }
  public get Berechnungsmethode(): FormControl {
    return this.controls["berechnungsmethode"] as FormControl;
  }
  public get FormularTyp(): FormControl {
    return this.controls["formularTyp"] as FormControl;
  }
  public get Fragen(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsFrageDisplayModelFormGroup> {
    return this.controls["fragen"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsFrageDisplayModelFormGroup>;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Infotext(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["infotext"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get KurzTitel(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["kurzTitel"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get Name(): FormControl {
    return this.controls["name"] as FormControl;
  }
  public get ParentId(): FormControl {
    return this.controls["parentId"] as FormControl;
  }
  public get Reihenfolge(): FormControl {
    return this.controls["reihenfolge"] as FormControl;
  }
  

}

export module AbschnittDisplayModelForm
  {
    export class FormFields
    {
      static _abschnitte: string = "abschnitte";
      static _beantragteFoerdersumme: string = "beantragteFoerdersumme";
      static _berechnungsmethode: string = "berechnungsmethode";
      static _formularTyp: string = "formularTyp";
      static _fragen: string = "fragen";
      static _id: string = "id";
      static _infotext: string = "infotext";
      static _kurzTitel: string = "kurzTitel";
      static _name: string = "name";
      static _parentId: string = "parentId";
      static _reihenfolge: string = "reihenfolge";
    }
  }

